import * as React from 'react';
import sanitizeHtml from 'sanitize-html';

import Tooltip from 'components/Tooltip';
import DeliverableMediaStatusMark from '../DeliverableMediaStatusMark';
import DeliverableMediaRowChild from './row-child/DeliverableMediaRowChild';

import { expandDataProps } from 'utils/helper/common';

import type { Data, DeliverableMediaStatus } from 'types';

type Props = {
  canUpload?: boolean,
  title: string,
  comment?: string,
  tooltip?: string,
  content: React.ReactNode | undefined | null,
  contentCentered?: boolean,
  status: DeliverableMediaStatus,
  contextMenu?: React.ReactNode | null,
  data?: Data,
  withExtendedChildHeight?: boolean
};

const SANITIZE_HTML_CONFIG = {
  allowedAttributes: {
    a: ['href', 'target', 'rel', 'class']
  }
};

const EXTERNAL_CHANNEL_LINK_FORMAT =
  '<a href="https://www.$&.com" target="_blank" rel="noopener noreferrer" class="deliverable-media-row__comment-link">$&</a>';

class DeliverableMediaRow extends React.PureComponent<Props> {
  static defaultProps = {
    contentCentered: true
  };

  render(): React.ReactNode {
    const {
      canUpload,
      title,
      comment,
      tooltip,
      content,
      contentCentered,
      status,
      contextMenu,
      data,
      withExtendedChildHeight
    } = this.props;

    return (
      <div
        className="deliverable-media-row"
        {...expandDataProps(data)}
      >
        <div className="deliverable-media-row__title">
          <DeliverableMediaRowChild withExtendedHeight={withExtendedChildHeight}>
            <div className="deliverable-media-row__label">
              {
                tooltip &&
                  <div className="deliverable-media-row__tooltip">
                    <Tooltip
                      showQuestionMark
                      message={tooltip}
                    />
                  </div>
              }
              {title}
              <DeliverableMediaStatusMark
                status={status}
              />
            </div>
            {
              comment && canUpload &&
                <div
                  className="deliverable-media-row__comment"
                  dangerouslySetInnerHTML={{
                    __html: sanitizeHtml(
                      comment.replace(/(Instagram|YouTube|TikTok)/, EXTERNAL_CHANNEL_LINK_FORMAT),
                      SANITIZE_HTML_CONFIG
                    )
                  }}
                />
            }
          </DeliverableMediaRowChild>
        </div>
        <div className="deliverable-media-row__context-menu">
          <DeliverableMediaRowChild withExtendedHeight={withExtendedChildHeight}>
            <div className="deliverable-media-row__menu">
              {contextMenu}
            </div>
          </DeliverableMediaRowChild>
        </div>
        <div className="deliverable-media-row__content">
          {
            contentCentered
              ? (
                <DeliverableMediaRowChild withExtendedHeight={withExtendedChildHeight}>
                  {content}
                </DeliverableMediaRowChild>
              )
              : content
          }
        </div>
      </div>
    );
  }
}

export default DeliverableMediaRow;
